'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.sa_reboot', {
    url: 'sa_reboot',
    template: '<sa-reboot></sa-reboot>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/sa_reboot/end_user/sa_reboot.routes.js